//api 接口处理
import request from "@/utils/request.js";
export default {
    //话术标签列表
    getVerbalList(param) {
        return request.post("merchant/Content.speech/speechGroupList", param, false, true);
    },
    //话术标签更新
    getVerbalListInfo(param) {
        return request.post("merchant/Content.speech/speechGroupUpdate", param, false, true);
    },
    //话术标签删除
    getVerbalListDel(param) {
        return request.post("merchant/Content.speech/speechGroupDel", param, false, true);
    },
    //话术列表列表
    getVerbalLs(param) {
        return request.post("merchant/Content.speech/speechList", param, false, true);
    },
    //话术列表删除
    verbalLsDEL(param) {
        return request.post("merchant/Content.speech/speechDel", param, false, true);
    },
    //话术列表更新
    verbalLsInfo(param) {
        return request.post("merchant/Content.speech/speechUpdate", param, false, true);
    },
    //素材分组
    materialGroup(param) {
        return request.post("merchant/Content.material/materialGroup", param, false, true);
    },
    //素材分组
    materialList(param) {
        return request.post("merchant/Content.material/materialList", param, false, true);
    },
    //素材分组
    materialUpdate(param) {
        return request.post("merchant/Content.material/materialUpdate", param, false, true);
    },
    //素材删除
    materialDel(param) {
        return request.post("merchant/Content.material/materialDel", param, false, true);
    },
    //素材详情
    materialInfo(param) {
        return request.post("merchant/Content.material/materialInfo", param, false, true);
    },
    //素材更新
    materialUpdate(param) {
        return request.post("merchant/Content.material/materialUpdate", param, false, true);
    },
}